module.exports = __webpack_public_path__ + "img/icon_email_selected.87bb0641.svg";